/**
 * Utilitários de formatação de data para o padrão brasileiro (dd/mm/yyyy)
 * NUNCA usar fuso horário nas marcações
 */

/**
 * Formata uma data ISO (yyyy-mm-dd) para o padrão brasileiro (dd/mm/yyyy)
 * @param {string} dataISO - Data no formato yyyy-mm-dd
 * @returns {string} Data no formato dd/mm/yyyy
 */
export const formatarDataBR = (dataISO) => {
  if (!dataISO) return '';
  const [ano, mes, dia] = dataISO.split('-');
  return `${dia}/${mes}/${ano}`;
};

/**
 * Formata uma data ISO (yyyy-mm-dd) para exibição curta (dd/mm)
 * @param {string} dataISO - Data no formato yyyy-mm-dd
 * @returns {string} Data no formato dd/mm
 */
export const formatarDataCurta = (dataISO) => {
  if (!dataISO) return '';
  const [ano, mes, dia] = dataISO.split('-');
  return `${dia}/${mes}`;
};

/**
 * Converte data brasileira (dd/mm/yyyy) para ISO (yyyy-mm-dd)
 * @param {string} dataBR - Data no formato dd/mm/yyyy
 * @returns {string} Data no formato yyyy-mm-dd
 */
export const dataBRparaISO = (dataBR) => {
  if (!dataBR) return '';
  const [dia, mes, ano] = dataBR.split('/');
  return `${ano}-${mes}-${dia}`;
};

/**
 * Formata uma data Date para o padrão brasileiro (dd/mm/yyyy)
 * SEM aplicar fuso horário
 * @param {Date} date - Objeto Date
 * @returns {string} Data no formato dd/mm/yyyy
 */
export const formatarDateBR = (date) => {
  if (!date) return '';
  const dia = String(date.getDate()).padStart(2, '0');
  const mes = String(date.getMonth() + 1).padStart(2, '0');
  const ano = date.getFullYear();
  return `${dia}/${mes}/${ano}`;
};

/**
 * Formata hora no padrão HH:MM (sem segundos, sem fuso)
 * @param {string} hora - Hora em qualquer formato
 * @returns {string} Hora no formato HH:MM
 */
export const formatarHora = (hora) => {
  if (!hora) return '';
  // Remove segundos e fuso se existir
  return hora.substring(0, 5);
};

/**
 * Obtém o dia da semana abreviado em português
 * @param {string} dataISO - Data no formato yyyy-mm-dd
 * @returns {string} Dia da semana abreviado (Seg, Ter, etc)
 */
export const getDiaSemanaAbrev = (dataISO) => {
  if (!dataISO) return '';
  const dias = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
  // Criar data sem fuso horário
  const [ano, mes, dia] = dataISO.split('-');
  const date = new Date(ano, mes - 1, dia);
  return dias[date.getDay()];
};

/**
 * Obtém o dia da semana completo em português
 * @param {string} dataISO - Data no formato yyyy-mm-dd
 * @returns {string} Dia da semana completo (Segunda-feira, etc)
 */
export const getDiaSemanaCompleto = (dataISO) => {
  if (!dataISO) return '';
  const dias = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
  const [ano, mes, dia] = dataISO.split('-');
  const date = new Date(ano, mes - 1, dia);
  return dias[date.getDay()];
};

/**
 * Formata período para exibição
 * @param {string} dataInicioISO - Data início no formato yyyy-mm-dd
 * @param {string} dataFimISO - Data fim no formato yyyy-mm-dd
 * @returns {string} Período no formato "dd/mm/yyyy a dd/mm/yyyy"
 */
export const formatarPeriodo = (dataInicioISO, dataFimISO) => {
  return `${formatarDataBR(dataInicioISO)} a ${formatarDataBR(dataFimISO)}`;
};

/**
 * Verifica se é fim de semana (sem usar fuso horário)
 * @param {string} dataISO - Data no formato yyyy-mm-dd
 * @returns {boolean} true se for sábado ou domingo
 */
export const isFimDeSemana = (dataISO) => {
  if (!dataISO) return false;
  const [ano, mes, dia] = dataISO.split('-');
  const date = new Date(ano, mes - 1, dia);
  const dayOfWeek = date.getDay();
  return dayOfWeek === 0 || dayOfWeek === 6;
};

export default {
  formatarDataBR,
  formatarDataCurta,
  dataBRparaISO,
  formatarDateBR,
  formatarHora,
  getDiaSemanaAbrev,
  getDiaSemanaCompleto,
  formatarPeriodo,
  isFimDeSemana
};
